import { TruckDriver } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAll(): Promise<readonly TruckDriver[]> {
  return DesignService.get('truckDrivers');
}

export function insert(name: string): Promise<TruckDriver> {
  return DesignService.post('truckDrivers', { data: { name } });
}

export function setArchiveStatus(trailerGuid: string, archived: boolean): Promise<void> {
  return DesignService.post(`truckDrivers/${trailerGuid}/setArchiveStatus/${archived}`);
}
